/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import Enterprise from 'bundles/epic/data/defaults/Enterprise.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  enterpriseSearchShadow: boolean;
  enableMicroBadgeReporting: boolean;
  enableClipsInCollections: boolean;
  enableCourseBuilder: boolean;
  enableWESSandboxCheckout: boolean;
  enableRecruiterDashboardUpdates: any;
  enableRecruiterInvitationFlow: any;
  enableAssignLearningPaths: boolean;
  enableCourseProfiles: boolean;
  enableAdminSyncFlow: boolean;
  migrateEnterpriseContractProvisionActions: boolean;
  enableCatalogPageRedesign: boolean;
  showOrgLevelSkillsForOrg: any;
  enableNewLearnersPage: boolean;
  paymentGatewayToBeDisplayed: 'brainTreeWes' | 'stripeEnterpriseWes';
  isSelfServeInvoice: boolean;
  verifiedSkillsAbTestProgramOptInList: any;
  verifiedSkillsAbTest: boolean;
  contentAssignmentOrgRollout: any;
  showDifferentialPricing: boolean;
  enableWESCoach: boolean;
  enableBackupPaymentMethod: boolean;
  cb4ContactUsFormWithSecondaryCTA: boolean;
  contractScheduling: boolean;
  enterpriseContractInvoiceOrdersGraphql: boolean;
  determineUpdateCostsGraphql: boolean;
  useSynchronousEmailValidation: boolean;
  enableFreeTrialForWES: boolean;
  enableCentralizedContentLibrary: boolean;
  isDegreedIntegrationEnabled: boolean;
  tieredPricingEnabled: boolean;
  redesignVspCard: 'control' | 'grey' | 'yellow';
};

const NAMESPACE = 'Enterprise';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([Enterprise as $TSFixMe]);

const EnterpriseEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default EnterpriseEpicClient;
